import { InvoicePaymentCollection, ValidateInvoicePayment } from "@auer-steel/Services/InvoicePaymentService";
import { AuerActions } from "@auer-steel/Store/AuerState";
import { convertToApiParameter, getInvoicePaymentDiscountAmount } from "@auer-steel/Utilities/PayInvoiceUtilities";
import isNumeric from "@insite/client-framework/Common/isNumeric";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import produce from "immer";
import { DispatchProp } from "react-redux";

type HandlerType = ApiHandler<InvoicePaymentCollection, InvoicePaymentCollection, DispatchProp<AuerActions>>;

export const UpdateInvoicePayments: HandlerType = async props => {
    const validationParameter = convertToApiParameter(props.parameter);
    const validationResult = await ValidateInvoicePayment(validationParameter);
    props.dispatch({ type: "Pages/PayInvoice/UpdateValidationResult", parameter: validationResult });
    

    const updatedParameter = {
        ...props.parameter,
        invoicePayments: produce(props.parameter.invoicePayments, draft => {
            draft.forEach(invoice => {
                invoice.discountAmount = getInvoicePaymentDiscountAmount(invoice);
            });
        }),
    };
    props.dispatch({ type: "Pages/PayInvoice/UpdateInvoicePayments", parameter: updatedParameter });
};

export const chain = [UpdateInvoicePayments];

const updateInvoicePayments = createHandlerChainRunner(chain, "UpdateInvoicePayments");
export default updateInvoicePayments;
